<div class="lum-auth">
  <div *ngIf="!validToken" class="kt-login__form">
    <div class="lum-auth-title">
      <h3>Link Expired</h3>
    </div>
    <p>This password reset link has expired.<br />Please try again.</p>
    <div class="lum-auth-actions">
      <a
        id="kt_login_signup_cancel"
        routerLink="/auth/login"
        [disabled]="loading"
        class="lum-button lum-button--secondary my-6"
        >Back to Login</a
      >
    </div>
  </div>

  <div *ngIf="validToken" class="kt-login__form">
    <div class="lum-auth-title">
      <h3>Create New Password</h3>
    </div>

    <form
      class="lum-auth-form"
      autocomplete="off"
      [formGroup]="recoverForm"
      (submit)="handleSubmit($event)"
    >
      <div class="form-group lum-auth-form-group">
        <input
          type="password"
          placeholder="Enter your new password"
          formControlName="password"
          arial-label="New Password"
          autocomplete="off"
          class="lum-input lum-input--primary lum-auth-input"
          [ngClass]="{
            'lum-auth-input--has-error': isControlHasError('password', 'required'),
          }"
          [translate]="'FORM.INPUT.PASSWORD'"
        />
        <div class="lum-auth-input-error">
          <mat-error *ngIf="isControlHasError('password', 'required')">
            <strong>Password is required</strong>
          </mat-error>
          <mat-error *ngIf="isControlHasError('password', 'minlength')">
            <strong>Password must be at least 8 characters long</strong>
          </mat-error>
        </div>
      </div>

      <div class="lum-auth-actions">
        <button
          type="submit"
          id="kt_login_signin_submit"
          class="lum-button lum-button--primary"
          [ngClass]="{
            'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light':
              loading,
          }"
          >Save New Password</button
        >
        <a
          id="kt_login_signup_cancel"
          class="lum-button lum-button--link"
          routerLink="/auth/login"
          >Back to Login</a
        >
      </div>
    </form>
  </div>
</div>
